class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Hover-to-open on devices that support hover (skips touch / mobile drawer).
    const hoverMQ = window.matchMedia('(hover: hover) and (min-width: 990px)');
    this._closeTimer = null;
    const open = () => {
      if (!hoverMQ.matches) return;
      window.clearTimeout(this._closeTimer);
      if (!this.mainDetailsToggle.open) this.mainDetailsToggle.setAttribute('open', '');
    };
    const scheduleClose = () => {
      if (!hoverMQ.matches) return;
      window.clearTimeout(this._closeTimer);
      this._closeTimer = window.setTimeout(() => this.close(), 120);
    };
    this.addEventListener('mouseenter', open);
    this.addEventListener('mouseleave', scheduleClose);
    // Keep open while hovering the dropdown panel itself
    this.mainDetailsToggle.addEventListener('mouseenter', open);
    this.mainDetailsToggle.addEventListener('mouseleave', scheduleClose);

    // Title text is a link: clicking it must navigate, not toggle the dropdown.
    // preventDefault cancels the summary toggle, so navigate manually.
    const summaryLink = this.mainDetailsToggle.querySelector(':scope > summary > a[href]');
    if (summaryLink) {
      summaryLink.addEventListener('click', (event) => {
        event.preventDefault();
        window.location.href = summaryLink.href;
      });
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
